import clsx from 'clsx';

export interface MouseScrollIconProps {
	className?: string;
}

export function MouseScrollIcon({ className }: MouseScrollIconProps) {
	return (
		<svg
			viewBox='-4 -4 32 32'
			fill='none'
			className={clsx('size-[1.75em] text-gray-a12', className)}
			aria-hidden='true'
		>
			{/* mouse body */}
			<path
				d='M12 4.5 C8.74 4.5 6.5 6.74 6.5 9.5 V15 C6.5 17.76 8.74 20 12 20 C15.26 20 17.5 17.76 17.5 15 V9.5 C17.5 6.74 15.26 4.5 12 4.5 Z'
				stroke='currentColor'
				strokeOpacity={0.5}
				strokeWidth={1.4}
				fill='none'
			/>
			{/* scroll wheel highlighted */}
			<rect
				x='10.1'
				y='6.6'
				width='3.8'
				height='6.6'
				rx='1.4'
				fill='currentColor'
				fillOpacity={1}
				transform='translate(12 6.6) scale(0.7 0.85) translate(-12 -6.6)'
			/>
			{/* chevrons above / below wheel */}
			<g
				stroke='currentColor'
				strokeOpacity={0.5}
				strokeWidth={1.5}
				strokeLinecap='round'
				strokeLinejoin='round'
				fill='none'
			>
				<path d='M9 -0.5 L12 -3 L15 -0.5' />
				<path d='M9 25 L12 27.5 L15 25' />
			</g>
		</svg>
	);
}
